import { Capacitor } from '@capacitor/core';

/**
 * Retour haptique — wrapper unifié au-dessus de @capacitor/haptics.
 *
 * Sur Android/iOS natif (Capacitor), on utilise le moteur haptique de l'OS
 * (precis, basse latence). Sur le web, on retombe sur l'API Vibration du
 * navigateur (navigator.vibrate) quand elle est disponible. Toutes les
 * fonctions sont « fire-and-forget » : elles n'attendent pas et n'échouent
 * jamais bruyamment, pour ne jamais bloquer une interaction.
 */

const isNative = Capacitor.isNativePlatform();

// Import paresseux du plugin natif (évite de le charger sur le web).
let _haptics = null;
let _styles = null;
const loadNative = async () => {
  if (_haptics) return _haptics;
  const mod = await import('@capacitor/haptics');
  _haptics = mod.Haptics;
  _styles = { ImpactStyle: mod.ImpactStyle, NotificationType: mod.NotificationType };
  return _haptics;
};

const webVibrate = (pattern) => {
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    try { navigator.vibrate(pattern); } catch { /* no-op */ }
  }
};

/** Tape légère — ex. chaque incrément du Tasbih. */
export const hapticTick = () => {
  if (isNative) {
    loadNative().then((h) => h.impact({ style: _styles.ImpactStyle.Light })).catch(() => {});
  } else {
    webVibrate(15);
  }
};

/** Impact moyen — ex. validation d'un bouton important. */
export const hapticImpact = () => {
  if (isNative) {
    loadNative().then((h) => h.impact({ style: _styles.ImpactStyle.Medium })).catch(() => {});
  } else {
    webVibrate(30);
  }
};

/** Vibration de succès / complétion d'un cycle (33, 99, 100…). */
export const hapticSuccess = () => {
  if (isNative) {
    loadNative()
      .then((h) =>
        h.notification
          ? h.notification({ type: _styles.NotificationType.Success })
          : h.vibrate({ duration: 180 })
      )
      .catch(() => {});
  } else {
    webVibrate([60, 40, 60]);
  }
};

/** Changement de sélection (onglet, segment). */
export const hapticSelection = () => {
  if (isNative) {
    loadNative()
      .then((h) => (h.selectionChanged ? h.selectionChanged() : h.impact({ style: _styles.ImpactStyle.Light })))
      .catch(() => {});
  } else {
    webVibrate(10);
  }
};
